import { DataServer } from "../../../config.axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

interface ProjectStatusState {
  ProjectStatus: {
    load: boolean;
    data: [];
  };
}

export const ProjectStatusSlice = createSlice({
  name: "ProjectStatus",
  initialState: {
    ProjectStatus: {
      load: false,
      data: [],
    },
  } as ProjectStatusState,
  reducers: {},
  extraReducers: (builder: any) => {
    builder
      .addCase(fetchProjectStatus.pending, (state: ProjectStatusState) => {
        state.ProjectStatus.load = true;
      })
      .addCase(fetchProjectStatus.fulfilled, (state: ProjectStatusState, action: any) => {
        state.ProjectStatus.data = action.payload;
        state.ProjectStatus.load = false;
      })
      .addCase(fetchProjectStatus.rejected, (state: ProjectStatusState) => {
        state.ProjectStatus.load = false;
      });
  },
});

export default ProjectStatusSlice.reducer;

export const fetchProjectStatus = createAsyncThunk(
  "ProjectStatus/fetchProjectStatus",
  async (param: {apiParam: {project_pin: any, layout_id : any}}) => {
    try {
      const { data } = await DataServer.post("api/getCompletedProjectStatus", {
        project_pin: param.apiParam.project_pin,
        layout_id: param.apiParam.layout_id
      });
      return data.data;
    } catch (error) {
      return error;
    }
  }
);
